<template>
  <zen-one :showuserinfo="false" :title="'Welcome to ' + $page.props.app_name">
    
    <z-animate-number value="29"></z-animate-number>

    <w-flex class="grow justify-space-betweenx basis-zero">

    <z-dashboard-item 
    class="box sh1 mb3 mr3" 
    :use-icon="false" 
    :use-slot="true" 
    >
      <template #header>
      <span class="success text-bold"><i class="mr1 fal fa-chart-line"></i> 29.28 %</span>
      </template>

      <template #title>
        <h5 class="mb-0 mt3 success">Prestasi Kutipan 2020 dan 2021</h5> 
      </template>

      <template #subtitle>
        <p class="mb1 mt1 text-truncate warning">Perbezaan Peratus Kutipan</p>
      </template>

      <template #zdileftbox>
        <div style="height:180px;width: 180px; display: flex;flex-direction:column;">
        <vue3-chart-js
            :id="doughnutChart.id"
            :type="doughnutChart.type"
            :data="doughnutChart.data"
            :options="doughnutChart.options"
            @before-render="beforeRenderLogic"
        ></vue3-chart-js>
        </div>
      </template>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box sh1 mb3 mr3" 
      :use-icon="false"
      image="/images/sample/map.svg" 
      text='KS' 
      width=""
      height=""
      header='<span class="success text-bold"><i class="mr1 fal fa-chart-bar"></i> 242%</span>'
      title='Kota Setar'
      subtitle='Kutipan Hasil Keseluruhan Koding'
    >
      <w-tag color="primary" bg-color="light-blue-5" class="sh1">
        <w-icon class="mr1" sm>
          fal fa-search
        </w-icon>
        73,536,980.00
      </w-tag>

      <w-tag color="white" bg-color="success-dark1" class="ml1 sh1">
        <w-icon class="mr1" sm>
          fal fa-dollar-sign
        </w-icon>
        42,405,711.94
      </w-tag>
    </z-dashboard-item>

    <z-dashboard-item 

      class="box sh1 mb3" 
      :use-icon="false"
      image="/images/sample/sik.svg" 
      text='' 
      width=""
      height=""
      header='<span class="success text-bold"><i class="mr1 fal fa-chart-bar"></i> 131.58%</span>'
      title='Sik'
      subtitle='<span class="primary">Kutipan Hasil Keseluruhan Koding</span> '
    >
      <w-tag color="primary" bg-color="light-blue-5" class="sh1">
        <w-icon class="mr1" sm>
          fal fa-search
        </w-icon>
        21,838,580.00
      </w-tag>

      <w-tag color="white" bg-color="success-dark1" class="ml1 sh1">
        <w-icon class="mr1" sm>
          fal fa-dollar-sign
        </w-icon>
        28,734,748.01
      </w-tag>
    </z-dashboard-item>

    </w-flex>

    <z-page class="white--bg mt3 sh2" title="PEJABAT PENGARAH TANAH DAN GALIAN NEGERI KEDAH">
    <template #title>
      <w-toolbar>
        <div class="title4">
          <w-icon
          class="primary size--md"
          >
            fal fa-user
          </w-icon> Apa Khabar Penjejak Badai!</div>
        <div class="spacer"></div>
        <span class="ml2">
          <w-icon>
          fal fa-sort
          </w-icon>
        </span>
      </w-toolbar>
    </template>

    <w-image
      src="/images/sample/wave2.png"
      
      height="200"
      width="100%"
    >
    </w-image>


    <p class="justify">
    <strong class="primary">Penjejak Badai</strong> adalah salah satu daripada watak utama dalam cerita ini. Dia adalah anak murid Wira Utama yang mewarisi  Hikmat <em>TENDANGAN ANGIN PUYUH</em>. Hikmat ini adalah hikmat yang mementingkan kepantasan dan kelincahan gerak tendangan. Sesiapa yang mahir dengan hikmat ini juga secara tidak langsung akan dapat melayangkan dirinya diudara dengan sesuka hatinya
    Hikmat Penjejak Badai mempunyai kepantasan yang tak terhingga.<br /><br />
    </p>
    <p>
    Diantara Hikmat yang dikuasai oleh Penjejak Badai adalah:-<br /><br />
    </p>
    <p>
    <ol class="ml5">
      <li>Tendangan Angin Puyuh</li>
      <li>Badai Lalu Bangunan Runtuh</li>
      <li>Angin Menderu Hujan Mencurah</li>
      <li>Tendangan Keramat Badai</li>
      <li>Angin Kencang Dengan Hujan Lebat</li>
      <li>Gaya Angin Menyapu Sisa Awan</li>
    </ol>
    <br /><br />
    </p>

    </z-page>
  </zen-one>
</template>

<script>


import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs
},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'bar',
      data: {
        labels: ['2020', '2021'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [64.74, 94.63]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }
  
    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}   
    }    

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
  showCard: false,
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
}
}

</script>

<style>


</style>